import createReducer from '../utils/createReducer';

export const initialState = {};

export const reducer = createReducer('common', initialState, {});

export default reducer;
